import React from 'react';
import IntegrationDocTemplate from '../../../../components/IntegrationDocTemplate';

export default function DocsShipMonk() {
  return (
    <IntegrationDocTemplate
      title="ShipMonk"
      category="Warehousing · 3PL"
      status="live"
      summary="AI-powered 3PL with 200+ ecommerce platform integrations. REST API, multichannel-optimized. Pay-per-unit. Best for high-SKU D2C brands."
      prerequisites={[
        'ShipMonk account (apply at shipmonk.com).',
        'API token from ShipMonk dashboard.',
      ]}
      connectSteps={[
        'Text us "ShipMonk" with your phone number.',
        'Paste your API token.',
        'First sync: inventory ledger + recent orders + receiving records.',
      ]}
      syncedData={[
        { type: 'Orders', detail: 'Create/get/cancel; multichannel routing supported' },
        { type: 'Inventory', detail: 'Per-SKU + per-warehouse stock; inventory ledger for variance tracking' },
        { type: 'Shipments', detail: 'Carrier + tracking + delivery status' },
        { type: 'Returns', detail: 'Customer returns + restocking' },
      ]}
      agents={[
        { id: 'order_router_agent', name: 'order_router_agent', role: 'Routes orders to ShipMonk vs other 3PLs' },
        { id: 'three_pl_compliance_agent', name: 'three_pl_compliance_agent', role: 'Daily SLA monitoring' },
      ]}
      troubleshooting={[
        { question: 'TikTok Shop integration', answer: 'ShipMonk added native TikTok Shop integration in 2026. Use their TikTok channel + our channel mapping.' },
      ]}
      supportLink="/contact"
    />
  );
}
